import { createRequestTypes, createActions } from "../../global/utilities";

export const ACCOUNTS = createRequestTypes("ACCOUNTS");

export const accountsRequest = () => createActions(ACCOUNTS["REQUEST"]);
export const accountsSuccess = data =>
  createActions(ACCOUNTS["SUCCESS"], { data });
export const accountsError = error =>
  createActions(ACCOUNTS["ERROR"], { error });
